export default __webpack_public_path__ + "static/media/i-open-tab-ko.27b05869.svg";